import FetchSettings from "../../interfaces/FetchSettings";
import OracleContentProvider from "./OcontentProvider";

export default class OcontentTwitterPanelProvider extends OracleContentProvider {
  async getAccounts(categorySlug: string): Promise<string[]> {
    try {
      const url = new URL(this.baseUrl + "twitter-accounts/" + categorySlug);
      const settings: FetchSettings = {
        method: "GET",
      };

      const res = await this.request<Response>(url.toString(), settings, true);
      const accountString = await res.text();

      return accountString.split(",");
    } catch (error) {
      console.error(error);
      return [];
    }
  }
}
